import { createApiThunk } from "./thunkWrapper";

// Login
export const loginUser = createApiThunk("auth/login", (payload) => ({
  method: "POST",
  endPoint: "login", // points to api_endpoints.login
  data: payload,
}));

// Register
export const registerUser = createApiThunk("auth/register", (payload) => ({
  method: "POST",
  endPoint: "register",
  data: payload,
}));

// Logout
export const logoutUser = createApiThunk("auth/logout", () => ({
  method: "POST",
  endPoint: "logout",
}));

// send otp
export const sendOtpApi = createApiThunk("auth/sendOtp", (payload) => ({
  method: "POST",
  endPoint: "sendOtpApi",
  data: payload,
}));
export const verifyOtpApi = createApiThunk("auth/verifyOtp", (payload) => ({
  method: "POST",
  endPoint: "verifyOtpApi",
  data: payload,
}));
export const setPasswordApi = createApiThunk("auth/setPassword", (payload) => ({
  method: "POST",
  endPoint: "setPasswordApi",
  data: payload,
}));
export const changePasswordApi = createApiThunk("auth/changePassword", (payload) => ({
  method: "POST",
  endPoint: "changePasswordApi",
  data: payload,
}));


// Get Current Student Info
export const getStudent = createApiThunk("auth/getStudent", () => ({
  method: "GET",
  endPoint: "getStudent",
}));
